module.exports = __webpack_public_path__ + "static/img/page_PLAY_over.e83daa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/series1/course1/page_PLAY_over.png
// module id = RCSe
// module chunks = 0